module.exports = __webpack_public_path__ + "media/WordPlayMontage_01_720.afd5e9b7.mp4";